import React, { createContext, useContext, useState } from 'react';
import propTypes from 'prop-types';
import { Box } from '@mui/material';

const StepperContext = createContext({
  backDisabled: false,
  nextDisabled: false,
  setBackButtonDisabled: () => {},
  setNextButtonDisabled: () => {},
});

export const StepperProvider = ({ children }) => {
  const [backDisabled, setBackButtonDisabled] = useState(false);
  const [nextDisabled, setNextButtonDisabled] = useState(false);

  return (
    <StepperContext.Provider value={{ backDisabled, nextDisabled, setBackButtonDisabled, setNextButtonDisabled }}>
      {children}
    </StepperContext.Provider>
  );
}

StepperProvider.propTypes = {
  children: propTypes.any,
}

export const useStepperController = () => useContext(StepperContext);

export default function StepBackBone({ children }) {
  return (
    <Box sx={{ p: 3, flexGrow: 1, overflow: 'auto' }}>
      {children}
    </Box>
  );
}

StepBackBone.propTypes = {
  children: propTypes.any,
}
